<template>
  <div>
    <template
      v-if="tabName === 'wechat'"
    >
      <switch-control
        :key="tabName"
        :title="`${qwTitTxt}：`"
      />
    </template>
    <template
      v-if="tabName === 'wexin'"
    >
      <switch-control
        :key="tabName"
        :title="`${wxNoticeTit}：`"
      />
      <p class="weixin-tips">
        {{ $t('message["565"]') }}
      </p>
    </template>
    <template
      v-else-if="tabName === 'dingtalk'"
    >
      <switch-control
        :key="tabName"
        :title="dingDingNTit"
      />
    </template>
    <template
      v-else-if="tabName === 'sms'"
    >
      <switch-control
        :key="tabName"
        :title="smsNTit"
      />
      <div class="msg-number-list">
        <span>{{ $t('message["254"]') }}：</span>
        <em>{{ smsEmail.smsnum }} {{ $t('message["1199"]') }}</em>
        {{ $t('message["1519"]') }}
        <a-input
          class="input-sms-number"
          :default-value="smsEmail.sms_notice_num"
          :placeholder="inputNumberPlace"
          @change="getSmsEmail"
        />
        <template slot="append">
          {{ $t('message["1199"]') }}
        </template>
        {{ $t('message["1079"]') }} <router-link :to="{name: 'ServiceSms'}">
          【{{ $t('message["395"]') }}】
        </router-link>
      </div>
    </template>
    <template
      v-else-if="tabName === 'email'"
    >
      <switch-control
        :key="tabName"
        :title="`${emailNoticeTit}：`"
      />
      <div class="msg-number-list">
        <span>{{ $t('message["1504"]') }}：</span>
        <em>{{ smsEmail.emailnum }}{{ $t('message["307"]') }}</em>
        {{ $t('message["1519"]') }}
        <a-input
          class="input-sms-number"
          :default-value="smsEmail.email_notice_num"
          :placeholder="inputNumberPlace"
          @change="getSmsEmail"
        />
        <template slot="append">
          {{ $t('message["307"]') }}
        </template>
        {{ $t('message["1079"]') }} <router-link :to="{name: 'ServiceEmail'}">
          【{{ $t('message["400"]') }}】
        </router-link>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import SwitchControl from './SwitchControl'
import { getClassVal } from '@/store/config/scripts.js'
export default {
  components: {
    SwitchControl
  },
  data () {
    return {
      isBlur: false
    }
  },
  computed: {
    ...mapState('config/notice', ['tabName', 'smsEmail']),
    dingDingNTit () {
      return this.$t('message["240"]')
    },
    smsNTit () {
      return this.$t('message["253"]')
    },
    qwTitTxt () {
      return this.$t('message["725"]')
    },
    inputNumberPlace () {
      return this.$t('message["1127"]')
    },
    wxNoticeTit () {
      return this.$t('message["1255"]')
    },
    emailNoticeTit () {
      return this.$t('message["1503"]')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('config/notice', ['setSmsEmailDatas']),
    async getSmsEmail (v) {
      // this.setSmsEmailDatas({
      //   'class': getClassVal(this.tabName),
      //   'num': v
      // })
      // setTimeout(async () => {
      //   const chain = await this.setSmsEmailDatas()
      //   chain.params({
      //     'class': getClassVal(this.tabName),
      //     'num': v.target.value
      //   })
      //     .fetch()
      // }, 1000)
      const chain = await this.setSmsEmailDatas()
      chain.params({
        'class': getClassVal(this.tabName),
        'num': v.target.value
      })
        .fetch()
    },
    setsmsEmail (d) {
    }
  }
}
</script>
<style lang="scss" scoped>
.msg-number-list::v-deep  {
  margin-bottom: 24px;

  span {
    margin-right: 16px;
  }

  em {
    margin-right: 10px;
  }

  .input-sms-number {
    width: 90px;
  }
}

.icon-tip-notice-normal-gr {
  color: #b3b3b3;
  font-size: 16px;
}

.emailpop-hover {
  width: 264px;
  padding: 16px;
  line-height: 16px;

  .email-tip-box em {
    color: #5077aa;
  }
}
.weixin-tips {
  color: #b3b3b3;
  padding-bottom: 24px;
  padding-top: 8px;
}
</style>
